

import templatePostDetailPage from '@/app-template/lib/pages/PostDetailPage.vue';

export default {
  name: "PostDetailPage",
  components: { templatePostDetailPage },
};
